import { Image_URL } from "../App";

export const ESSAY_MAX_CHARS = 20000;
export const ESSAY_MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const ESSAY_ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];

export function isEssayQuestion(question) {
  if (!question) return false;
  const type = question.type;
  if (!type) return false;
  return String(type).toLowerCase() === "essay";
}

export function resolveStorageUrl(path) {
  if (!path) return "";
  const value = String(path).trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  const cleaned = value.replace(/^\/+/, "");
  if (cleaned.startsWith("storage/")) {
    return `${Image_URL}/${cleaned}`;
  }
  return `${Image_URL}/storage/${cleaned}`;
}

export function hasEssayAnswer(questionOrState) {
  if (!questionOrState) return false;
  const text = (questionOrState.answer_text || "").trim();
  const image = questionOrState.answer_image || questionOrState.previewUrl;
  return Boolean(text || image);
}

export function parseManualGrade(value) {
  if (value === null || value === undefined || value === "") return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function parseDegree(value) {
  if (value === null || value === undefined || value === "") return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}
